class DetailsModal extends HTMLElement {
  static instances = [];
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.closeButton = this.querySelector('.modal-close-button');
    this.header.preventHide = false;
    this.detailsContainer.addEventListener('keyup', (e) => {
      if (e.code === 'Escape') this.close();
    });
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.summaryToggle.setAttribute('role', 'button');
    this.closeButton?.addEventListener('click', () => this.close());
    DetailsModal.instances.push(this);
  }
  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }
  onSummaryClick(e) {
    e.preventDefault();
    const details = e.target.closest('details');
    if (details.hasAttribute('open')) {
      this.close();
      this.header.preventHide = false;
    } else {
      this.open(e);
      if (this.header) this.header.preventHide = this.detailsContainer.open;
    }
  }
  onBodyClick(e) {
    if (!this.contains(e.target)) this.close(false);
  }
  open(e) {
    DetailsModal.instances.forEach((inst) => {
      if (inst.isOpen()) inst.close(false);
    });
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    e.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden-modal');
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
    if (
      this.header.parentNode.classList.contains('color-background-overlay') &&
      this.classList.contains('header__search')
    ) {
      this.header.parentNode.classList.remove('color-background-overlay');
      this.header.parentNode.classList.add('color-background-overlay-hidden');
    }
  }
  close(e = true) {
    removeTrapFocus(e ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden-modal');
    this.header.preventHide = false;
    if (
      this.header.parentNode.classList.contains('color-background-overlay-hidden') &&
      this.classList.contains('header__search')
    ) {
      this.header.parentNode.classList.remove('color-background-overlay-hidden');
      this.header.parentNode.classList.add('color-background-overlay');
    }
  }
}
customElements.define('details-modal', DetailsModal);

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    document.addEventListener('keyup', this.onKeyUp.bind(this));
    document.addEventListener('click', this.onFocusOut.bind(this));
  }
  onKeyUp(e) {
    if (e.code === 'Escape') {
      this.mainDetailsToggle.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
    }
  }
  onFocusOut(e) {
    if (!e.composedPath().includes(this.mainDetailsToggle)) {
      this.mainDetailsToggle.removeAttribute('open');
    }
  }
  close() {
    this.mainDetailsToggle.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
  }
}
customElements.define('details-disclosure', DetailsDisclosure);
